module.exports = __webpack_public_path__ + "bc4e91772bcd15780f1bb5695d2c4a37.woff2";